var map = {
	"./OA.svg": "28gC",
	"./academic.svg": "V0Oa",
	"./card.svg": "9l/A",
	"./classRoom.svg": "BIKf",
	"./copy.svg": "UBe8",
	"./course.svg": "4t1d",
	"./dashboard.svg": "BCGP",
	"./delete.svg": "Imjp",
	"./enrollment.svg": "0f7v",
	"./error.svg": "KCO8",
	"./example.svg": "OOLB",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./finance.svg": "pTuU",
	"./form.svg": "sTIr",
	"./frontDesk.svg": "TZJz",
	"./growthTrack.svg": "Kyfr",
	"./link.svg": "KgwQ",
	"./location.svg": "WhFt",
	"./mall.svg": "iD3t",
	"./message.svg": "G2zY",
	"./nested.svg": "798r",
	"./password.svg": "QjmH",
	"./retry.svg": "Cq0Y",
	"./service.svg": "nCjf",
	"./showBig.svg": "0fSM",
	"./statistics.svg": "2O5N",
	"./student.svg": "GMSZ",
	"./success.svg": "C5yd",
	"./system.svg": "Jax1",
	"./table.svg": "oSYw",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 1